import { render, staticRenderFns } from "./ReceiveServiceInvitation.vue?vue&type=template&id=6b610444&"
import script from "./ReceiveServiceInvitation.vue?vue&type=script&lang=ts&"
export * from "./ReceiveServiceInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports